import { useEffect, useContext } from 'react'

import {
  loadMap,
  setCounter
} from 'src/store/map/actions'

import { MapDataContext, MapDispatchContext } from 'src/store/map/Store'
import useLocation from './useLocation'

const useLoadMapGrid = () => {
  const { map } = useContext(MapDataContext)
  const { dispatchMap } = useContext(MapDispatchContext)

  const { location } = useLocation()
  const { location_id } = map.variables
  
  // sets the map from context
  useEffect(() => {
    if (location) {
      const { contentGrid, dayLightGrid, nightLightGrid } = location
      const lightGrid = map.switches.day_time ? dayLightGrid : nightLightGrid
      
      // sets location of player in map, sets map_loaded to true
      loadMap(dispatchMap, {
        lightGrid,
        contentGrid
      })

      // sets the tile_size
      const rowCount = contentGrid.length || 0
      const columnCount = contentGrid[0] ? contentGrid[0].length : 0
      const biggestCount = rowCount > columnCount ? rowCount : columnCount
      const newTileSize = (window.innerWidth <= 768 ? window.innerWidth : 400) / biggestCount
      setCounter(dispatchMap, 'tile_size', { '=': newTileSize })
    }
  }, [location_id, location])
}

export default useLoadMapGrid
